"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _gatsby = require("gatsby");

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _classnames = _interopRequireDefault(require("classnames"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _docTemplate = _interopRequireDefault(require("./styles/docTemplate"));

var _DocInfo = _interopRequireDefault(require("./DocInfo"));

var _DocTags = _interopRequireDefault(require("./DocTags"));

var DocContent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DocContent, _React$Component);

  function DocContent(props) {
    (0, _classCallCheck2.default)(this, DocContent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DocContent).call(this, props));
  }

  (0, _createClass2.default)(DocContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          isPreview = _this$props.isPreview,
          timeToRead = _this$props.timeToRead,
          formattedDate = _this$props.formattedDate,
          tags = _this$props.tags,
          title = _this$props.title,
          category = _this$props.category,
          slug = _this$props.slug,
          classes = _this$props.classes,
          className = _this$props.className;

      if (isPreview) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.root, 'markdown-body', className ? className : '')
        }, _react.default.createElement(_Typography.default, {
          className: classes.title,
          variant: "h4",
          color: "inherit",
          noWrap: true
        }, title), _react.default.createElement(_DocInfo.default, {
          formattedDate: formattedDate,
          timeToRead: timeToRead ? timeToRead : 0,
          category: category,
          isPreview: isPreview
        }), _react.default.createElement(_reactMarkdown.default, {
          source: content,
          className: "markdown-body",
          escapeHtml: false
        }), _react.default.createElement("div", {
          className: "doc-meta"
        }, _react.default.createElement(_DocTags.default, {
          tags: tags,
          isPreview: isPreview
        })));
      } else {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.root, 'markdown-body', className)
        }, _react.default.createElement(_DocInfo.default, {
          formattedDate: formattedDate,
          timeToRead: timeToRead,
          category: category,
          slug: slug
        }), _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: content
          }
        }), _react.default.createElement("div", {
          className: "doc-meta"
        }, _react.default.createElement(_DocTags.default, {
          tags: tags,
          isPreview: isPreview
        })));
      }
    }
  }]);
  return DocContent;
}(_react.default.Component);

DocContent.propTypes = process.env.NODE_ENV !== "production" ? {
  content: _propTypes.default.node.isRequired,
  formattedDate: _propTypes.default.string,
  title: _propTypes.default.string,
  category: _propTypes.default.string,
  tags: _propTypes.default.array,
  isPreview: _propTypes.default.bool
} : {};

var _default = (0, _styles.withStyles)(_docTemplate.default)(DocContent);

exports.default = _default;